
import React, {useEffect, useState} from 'react'
import TodoList from './Todo/TodoList'
import Context from './context'
import Loader from './Loader'
import Moment from 'react-moment'
import Explaintest from './ExplainTest'
import NavMenu from './NavMenu'

const AddTodo = React.lazy(()=>import('./Todo/AddTodo'))

function Test() {
  const [todos, setTodos] = useState([])
  const [loading, setLoading] = useState(true)

 
   useEffect(() => {
    console.log('restart')
  fetch('https://sleepy-shelf-75424.herokuapp.com/test')
      .then(response => response.json())
      .then(todos => {
          setTodos(todos)
          setLoading(false)
     })
   }, [])
  
  function changePrior(_id, priority) {
     setLoading(false)
    setTodos(todos.map(todo => {
      if (todo._id === _id) {
        console.log(priority)
        if (priority >= 0) {
          fetch('https://sleepy-shelf-75424.herokuapp.com/testpriority?_id=' + _id + "&priority=" + priority)
          .then(response => response.json())
          .then(todos => {
            setTodos(todos)
            setLoading(false)
          })
        }
      }
      return todo

    }))
  }
  
  function changeDate(_id, date)
  {
   setLoading(false)
    setTodos(todos.map(todo => {
      if (todo._id === _id) {
        console.log(date)
          fetch(' https://sleepy-shelf-75424.herokuapp.com/testdate?_id=' + _id + "&date=" + date)
          .then(response => response.json())
          .then(todos => {
            setTodos(todos)
            setLoading(false)
          })
         document.getElementById('datebefore'+_id).style.display = "block"
         document.getElementById('datebefore'+_id).value = date
        document.getElementById('dateafter'+_id).style.display = "none"
      }
      return todo

    }))
  }

function changeText(_id, text) {
  setLoading(false)
    setTodos(todos.map(todo => {
      if (todo._id === _id) {
        console.log(text)
          fetch('https://sleepy-shelf-75424.herokuapp.com/testtext?_id=' + _id + "&title=" + text)
          .then(response => response.json())
          .then(todos => {
            setTodos(todos)
            setLoading(false)
          })
         document.getElementById('textbefore'+_id).style.display = "none"
         document.getElementById('textbefore'+_id).innerText = text
      }
      return todo

    }))
}

  function toggleTodo(_id) {
          setLoading(false)
    setTodos(todos.map(todo => {
      if (todo._id === _id) {
        if (todo.completed === false) {
          fetch('https://sleepy-shelf-75424.herokuapp.com/testcompl?_id=' + _id + "&completed=" + true)
            .then(response => response.json())
            .then(todos => {
              setTodos(todos)
              setLoading(false)
            })
        }
      
        else {
          fetch('https://sleepy-shelf-75424.herokuapp.com/testcompl?_id=' + _id + "&completed=" + false)
          .then(response => response.json())
          .then(todos => {
            setTodos(todos)
            setLoading(false)
          })
        }
      }
      return todo
    })
    )
    
  }

  function removeTodo(_id) {
     setLoading(true)
    console.log(_id)
    fetch('https://sleepy-shelf-75424.herokuapp.com/testdel?_id='+_id)
      .then(response => response.json())
      .then(todos => {
          setTodos(todos)
          setLoading(false)
      })
      .then(data => console.log(data))
  }

  function addTodo(title, priority, date) {
     setLoading(true)
    fetch('https://sleepy-shelf-75424.herokuapp.com/testadd?date='+date+'&title='+title+'&priority='+priority, {
    })
      .then(response => response.json())
      .then(todos => {
          setTodos(todos)
          setLoading(false)
      })
      .then(data => console.log(data))
     
  }
  
  return (
      <Context.Provider value={{ removeTodo }}>
          <NavMenu/>
      <div className="wrapper">
        <Explaintest/>
        <div className="row"><div className="col-sm"><h1 className="head">План Тест</h1></div><div className="col-sm"><h3 className="head"><Moment format="DD.MM.YYYY" date={new Date()} className="date" /></h3></div></div>
        <React.Suspense fallback={<p>Загрузка...</p>}> <AddTodo onCreate={addTodo} /></React.Suspense>
        {loading && <Loader/>}
        {todos.length ? <TodoList todos={todos} onToggle={toggleTodo} Priority={changePrior} Date={changeDate} Text={changeText}/> :
          (loading ? null:<p>Нет пунктов!</p>)}
      </div>
      </Context.Provider>
  )
}

export default Test
//производная от приложения: https://www.youtube.com/watch?v=xJZa2_aldDs